(() => {
  'use strict';
  if (window.location.pathname.replace(/\/+$/, '') === '/pages/build-your-tmo-collection') return;
  // Bundle cart presentation intentionally runs only on cart surfaces.
})();
